import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import style from "./style.module.scss";
export default function DonutChart(props) {
    const { color, value, holeColor } = props;
    //calc value as degrees.
    const degrees = value * 3.6;
    const backgroundStyle = "conic-gradient(" + color + " 0 " + degrees + "deg, var(--subtle-emphasis)" + degrees + "deg 360deg)";
    const holeBackgroundStyle = holeColor ? holeColor : "var(--level_4)";
    return (_jsx("div", { className: classNames(style["donut-chart"], "qa-donut-chart"), style: { background: backgroundStyle }, children: _jsx("div", { className: style["donut-chart__hole"], style: { background: holeBackgroundStyle, color: color }, children: value }) }));
}
